import { render, staticRenderFns } from "./ExamsList.vue?vue&type=template&id=0fd1afa5&scoped=true&"
import script from "./ExamsList.vue?vue&type=script&lang=js&"
export * from "./ExamsList.vue?vue&type=script&lang=js&"
import style0 from "./ExamsList.vue?vue&type=style&index=0&id=0fd1afa5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1afa5",
  null
  
)

export default component.exports